import { Component, inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LimitedTimeEvent } from '@app/shared/models/limitedTimeEvent.model';
import { Modal, ModalConfig, ModalType, NonPersistedModalName } from '@app/shared/models/modal.model';
import { EventsRepository } from '@app/shared/state/events/events.repository';
import { SharedModule } from '@app/shared/shared.module';
import { EventManager } from '@app/shared/utils/event-manager';
import { TranslateService } from '@ngx-translate/core';
import { AnimatedTimerComponent } from '@app/shared/components/animated-timer/animated-timer.component';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { BoxComponent } from '@app/shared/components/liveops/box/box.component';

@Component({
  selector: 'slotcom-multiplier-prize-modal',
  templateUrl: './multiplier-prize.component.html',
  styleUrls: ['./multiplier-prize.component.scss'],
  standalone: true,
  imports: [ButtonComponent, BoxComponent, AnimatedTimerComponent, SharedModule],
})
export class MultiplierPrizeModalComponent implements OnInit {
  event: LimitedTimeEvent;
  lang: string;

  persistedModalData: ModalConfig;
  nonPersistedModalData: Modal;

  private readonly eventManager = inject(EventManager);
  private readonly eventsRepo = inject(EventsRepository);
  private readonly translateService = inject(TranslateService);
  protected readonly multiplierPrizeModalData = inject<Modal | ModalConfig>(MAT_DIALOG_DATA);

  ngOnInit(): void {
    if ('properties' in this.multiplierPrizeModalData) {
      this.persistedModalData = this.multiplierPrizeModalData;
      this.event = this.eventsRepo.getEventById(this.multiplierPrizeModalData.properties.eventId);
    } else {
      this.nonPersistedModalData = this.multiplierPrizeModalData;
      this.event = this.eventsRepo.getEventById(this.multiplierPrizeModalData.data.eventId);
    }

    this.lang = this.translateService.currentLang;
  }

  closeModal(): void {
    if (this.persistedModalData) {
      this.eventManager.closeModal(new Modal(this.persistedModalData.id, ModalType.Persisted, this.persistedModalData));
    } else {
      this.eventManager.closeModal(
        new Modal(NonPersistedModalName.MultiplierPrizeModalComponent, ModalType.View, this.nonPersistedModalData)
      );
    }
  }
}
